'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = require('../grid');

exports['default'] = _grid.Col;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/col/index.js
// module id = 1454
// module chunks = 0